import { prompt, promptSingle } from "~utils/prompt"
import { useStores } from "~models"
import useNavigation from "~hooks/useNavigation"

const useCheckBinding = () => {
  const navigation = useNavigation()
  const { userStore, walletStore } = useStores()
  const { currentUser = {} } = userStore
  const { is_phone_verify, is_pay_password } = currentUser

  const handleCheckBindingWpPassword = () => {
    return new Promise((resolve) => {
      if (is_pay_password || walletStore?.pay_pwd) {
        // 已绑定支付密码
        resolve({ message: "已绑定支付密码", type: "success" })
      } else {
        prompt({
          title: "提示",
          message: "请先设置支付密码",
          onSuccess: () => navigation.navigate("SettingPayNumber"),
          successText: "去设置",
          cancelText: "之后再说",
        })
        // reject({ message: "请先设置支付密码", type: "error" })
      }
    })
  }

  const handleCheckBindingPhone = () => {
    return new Promise((resolve) => {
      if (is_phone_verify || walletStore?.is_phone_verify) {
        // 已绑定手机
        resolve({ message: "已绑定手机", type: "success" })
      } else {
        promptSingle({
          title: "绑定提示",
          message: "请先绑定手机",
          onSuccess: () => navigation.navigate("PhoneBinding"),
          successText: "前往绑定",
        })
      }
    })
  }

  return { handleCheckBindingWpPassword, handleCheckBindingPhone }
}

export default useCheckBinding
